<template>
  <div id="app-user">
    <div class="user_container">
      <div class="user-title">
        <div class="user-title-one">
          <!-- <div class="tit-newYear">
            <span @click="openPickerCity" class="tit-newYear-sele"
              >{{ city }}
              <i v-if="cityPickerMonth !== true"
                ><van-icon name="arrow-down"
              /></i>
              <i v-else><van-icon name="arrow-up" /></i>
            </span>
            <van-popup
              v-model="cityPickerMonth"
              round
              get-container="body"
              position="bottom"
            >
              <van-picker
                show-toolbar
                title="选择城市"
                :columns="columnsCity"
                @cancel="cityPickerMonth = false"
                @confirm="confirmDateCity"
              />
            </van-popup>
          </div> -->
          <van-search class="tit-search" v-model="value" placeholder="请输入搜索关键词" @input="search" />
        </div>
        <div class="user-title-log">
          <img src="@/assets/hr/banner1.png" alt="" />
        </div>
      </div>
      <div class="user-content">
        <div class="tabsWrapper">
          <van-tabs class="vanTabs" v-model="tabsActive" @click="handleTabsActive">
            <van-tab title="岗位招聘" name="岗位招聘"></van-tab>
            <van-tab title="历史推荐" name="历史推荐"></van-tab>
          </van-tabs>
          <!-- 岗位招聘 -->
          <div class="con-title" v-if="tabsActive === '岗位招聘'">
            <span @click="openPickerDep" class="tit-newYear-sele">{{ depament }}
              <i v-if="depPickerMonth !== true"><van-icon name="arrow-down" /></i>
              <i v-else><van-icon name="arrow-up" /></i>
            </span>
            <van-popup v-model="depPickerMonth" round get-container="body" position="bottom">
              <van-picker show-toolbar title="岗位招聘" :columns="columnsDepa" @cancel="depPickerMonth = false"
                @confirm="confirmDateDepa" />
            </van-popup>
            <!-- <img src="@/assets/user/regards.png" alt="" /> -->
          </div>
          <!-- 历史推荐 -->
          <div class="con-title" v-if="tabsActive === '历史推荐'">
            <span @click="openPickerDep1" class="tit-newYear-sele">{{ depament1 }}
              <i v-if="depPickerMonth1 !== true"><van-icon name="arrow-down" /></i>
              <i v-else><van-icon name="arrow-up" /></i>
            </span>
            <van-popup v-model="depPickerMonth1" round get-container="body" position="bottom">
              <van-picker show-toolbar title="历史推荐" :columns="columnsDepa1" @cancel="depPickerMonth1 = false"
                @confirm="confirmDateDepa1" />
            </van-popup>
            <!-- <img src="@/assets/user/regards.png" alt="" /> -->
          </div>
        </div>
        <!-- 招聘 -->
        <van-list v-model="loading" v-if="tabsActive === '岗位招聘'" :finished="finished" finished-text="没有更多数据"
          @load="onLoad" offset="10" loading-text="加载中，下拉查看更多">
          <div class="con-content">
            <div class="content-center" v-for="(item, index) in list" :key="index">
              <div class="content-top" @click="toDetail(item.id)">
                <div class="content-topLeft">
                  <div>
                    {{ item.position_name }}
                    <span v-if="item.urgency_visible">{{
                      item.urgency_state
                    }}</span>
                  </div>
                  <div>
                    <span> {{ item.work_experience }} |</span>
                    <span>{{ item.education }}及以上 |</span>
                    <span>{{ item.work_addr }}</span>
                  </div>
                  <div>
                    <span v-for="v in item.jobType" :key="v">{{ v }}</span>
                  </div>
                </div>
                <div class="content-topRight">
                  <img v-if="item.send == 1" src="@/assets/user/ok.png" alt="" />
                </div>
              </div>
              <div class="content-depa" @click="toDetail(item.id)">
                <span>{{ item.orgName }}</span>
                <span v-if="item.bouns">推荐奖金：<a>{{ item.bouns }}</a></span>
              </div>
              <div class="content-footer">
                <div></div>
                <div>
                  <dl @click.stop="setMenu(item)">
                    <dt>
                      <img src="../../../assets/user/deliver.png" alt="" />
                    </dt>
                    <dd>投递</dd>
                  </dl>
                  <dl @click.stop="toShare(item)">
                    <dt><img src="../../../assets/user/share.png" alt="" /></dt>
                    <dd>分享</dd>
                  </dl>
                </div>
              </div>
            </div>
          </div>
        </van-list>
        <!-- 推荐 -->
        <van-list v-model="loading1" v-if="tabsActive === '历史推荐'" :finished="finished1" finished-text="没有更多数据"
          @load="onLoad1" offset="10" loading-text="加载中，下拉查看更多">
          <div class="con-content1">
            <div class="content-center" v-for="(item, index) in list1" :key="index">
              <div class="content-top" @click="toDetail(item.id)">
                <div class="content-topLeft">
                  <div class="topLeft">
                    <div class="topTitle">{{ item.positionName }}</div>
                    <div class="topRight" :class="item.interviewType == '2' ? 'titleGreen' : 'titleRed'">{{ item.interviewType=='2'?'内推':'自荐' }}</div>
                  </div>
                  <div class="topCenter">
                    <span> {{ item.workExperience }} | </span>
                    <span>{{ item.education }}及以上 | </span>
                    <span>{{ item.workAddr }}</span>
                  </div>
                  <div class="topCenter1">
                    被推荐人姓名：{{ item.empName }}
                  </div>
                </div>
                <!-- <div class="content-topRight">
                  <img v-if="item.send == 1" src="@/assets/user/ok.png" alt="" />
                </div> -->
              </div>
            </div>
          </div>
        </van-list>
      </div>
      <div class="menu">
        <van-overlay :show="menu" @click="menu = false">
          <div class="menu-log">
            <div @click.stop="toUrlOne">内推（推荐他人）</div>
            <div @click.stop="toUrlTwo">自荐（内部竞聘）</div>
            <div @click.stop="menu = false">取消</div>
          </div>
        </van-overlay>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/apis/user";
import { getToken } from "@/utils/cookie";
export default {
  name: "HR",
  data() {
    return {
      // cityPickerMonth: false,
      depPickerMonth: false,
      depPickerMonth1: false,
      value: "",
      columnsCity: [],
      columnsDepa: [
        {
          text: "内部招聘",
          value: "1",
        },
        {
          text: "外部招聘",
          value: "2",
        },
        {
          text: "全部",
          value: "3",
        },
      ],
      columnsDepa1: [
        {
          text: "内推",
          value: "1",
        },
        {
          text: "自荐",
          value: "2",
        },
      ],
      depament: "全部",
      depament1: "内推",
      list: [],
      list1: [],
      menu: false,
      detail: "",
      uuid: "",
      loading: false,
      loading1: false,
      finished: false,
      finished1: false,
      pageNum: 0,
      pageShow: 10,
      totalAll: 0,
      pageNum1: 0,
      pageShow1: 10,
      totalAll1: 0,
      tabsActive: '岗位招聘'
    };
  },
  created() { },
  mounted() {
    // this.getList();
    this.getUUid();
  },
  methods: {
    //跳转到分享
    toShare(item) {
      this.$router.push({ path: "/mobile/user/share", query: { id: item.id } });
    },
    //获取uuid
    getUUid() {
      api.uuid().then((data) => {
        this.uuid = data.data;
      });
    },
    //跳转到详情
    toDetail(id) {
      this.$router.push({
        path: "/mobile/user/detail",
        query: {
          type: this.tabsActive=='历史推荐'? this.depament1=='内推'?'1':'2'  :'1',
          id: id,
          uuid: this.uuid,
          tabsActive:this.tabsActive
        },
      });
    },
    onLoad() {
      // console.log(123);
      setTimeout(() => {
        this.getList();
      }, 500);
    },
    onLoad1() {
      // console.log(123);
      setTimeout(() => {
        this.getList1();
      }, 500);
    },
    //搜索
    search(value) {
      if (value.length >= 1) {
        this.pageNum = 0;
        this.getList();
        this.pageNum1 = 0;
        this.getList1();
      } else {
        this.finished = false;
        this.finished1 = false;
        this.loading = false;
        this.loading1 = false;
        this.pageNum = 0;
        this.pageNum1 = 0;
        this.getList();
        this.getList1();
      }
      // this.getList();
    },
    handleTabsActive() {
      this.value=''
      if (this.tabsActive === '岗位招聘') {
        this.pageNum=0
        this.getList();
      }
      if (this.tabsActive === '历史推荐') {
        this.pageNum1=0
        this.getList1();
      }
    },
    //显示岗位招聘
    openPickerDep() {
      this.depPickerMonth = true;
    },
    //确认岗位招聘
    confirmDateDepa(value) {
      this.depPickerMonth = false;
      this.depament = value.text;
      this.pageNum = 0;
      // this.list = []
      this.getList();
    },
    //确认历史推荐
    confirmDateDepa1(value) {
      this.depPickerMonth1 = false;
      this.depament1 = value.text;
      this.pageNum1 = 0;
      // this.list = []
      this.getList1();
    },
    //显示历史推荐
    openPickerDep1() {
      this.depPickerMonth1 = true;
    },
    //投递
    setMenu(item) {
      this.menu = true;
      this.detail = item.id;
    },
    //跳转到详情
    toUrlOne() {
      this.$router.push({
        path: "/mobile/user/detail",
        query: {
          type: "1",
          id: this.detail,
          uuid: this.uuid,
        },
      });
    },
    //跳转到详情
    toUrlTwo() {
      this.$router.push({
        path: "/mobile/user/detail",
        query: {
          type: "2",
          id: this.detail,
          uuid: this.uuid,
        },
      });
    },
    //获取岗位招聘
    getList() {
      let obj = {
        job_type: this.depament == '全部' ? '' : this.depament,
        other: this.value,
        empNo: getToken(),
        pageNum: this.pageNum,
        pageShow: this.pageShow,
      };
      api
        .hrRecommendPostInfo({ ...obj })
        .then((data) => {
          // this.list = data.data;
          this.totalAll = data.position_total;
          this.finished = false;
          if (this.pageNum === 0) {
            this.list = data.data;
          } else {
            this.list = this.list.concat(data.data);
          }

          if (this.list.length < this.totalAll) {
            this.pageNum = this.pageNum + 1;
          } else {
            this.finished = true;
          }
          this.loading = false;
          this.list.forEach((item) => {
            item.jobType = item.job_type.split("|");
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    //获取历史推荐
    getList1() {
      let obj = {
        interviewType: this.depament1=='内推'?2:1,
        other: this.value,
        empNo: getToken(),
        // empNo:10000044,
        page: this.pageNum1+1,
        pageSize: this.pageShow1,
      };
      api
        .queryHistorySuggest({ ...obj })
        .then((data) => {
          // this.list = data.data;
          this.totalAll1 = data.total;
          this.finished1 = false;
          if (this.pageNum1 === 0) {
            this.list1 = data.data.list;
          } else {
            this.list1 = this.list1.concat(data.data);
          }

          if (this.list1.length < this.totalAll1) {
            this.pageNum1 = this.pageNum1 + 1;
          } else {
            this.finished1 = true;
          }
          this.loading1 = false;
          this.list1.forEach((item) => {
            item.jobType = item.job_type.split("|");
          });
        })
        .catch(() => {
          this.loading1 = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  #app-user {
    width: 100%;
  }
}

@media screen and (min-width: 600px) {
  #app-user {
    width: 276px * $zoom;
  }
}

#app-user {
  font-size: 16px * $zoom;
  position: relative;

  .user_container {
    width: 100%;
    min-height: 100vh;
    background: #f7f9fa;

    .user-title {
      width: 100%;
      height: 455px;
      background: #fff;
      padding: 25px;

      .user-title-one {
        width: 100%;

        // display: flex;
        // align-items: center;
        // .tit-newYear {
        //   font-size: 26px;
        // }
        .tit-search {
          width: 100%;

          ::v-deep .van-search__content {
            border-radius: 20px;
          }
        }

        ::v-deep .van-search {
          padding: 10px 0 !important;
        }
      }

      .user-title-log {
        img {
          width: 100%;
          height: 310px;
        }
      }
    }

    .user-content {
      padding: 25px;

      .tabsWrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;

        ::v-deep .van-tab {
          width: 130px;
          background-color: #F7F9FA;
          // padding-right: 25px;
          color: #969B9E;
          margin-right: 55px;
        }

        ::v-deep .van-tabs__nav--line {
          background-color: #F7F9FA;
        }

        ::v-deep(.van-tabs__line) {
          width: 34px;
          height: 6px;
          background-color: #4EA27C;
          bottom: 35px;
          background: #4EA27C;
          border-radius: 11px;
        }

        ::v-deep(.van-tab--active) {
          color: #282B32;
          font-weight: 800;
        }
      }

      .con-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 26px;

        .tit-newYear-sele {
          display: block;
          width: 150px;
          font-weight: 400;
          color: #282B32;
          font-size: 25px;
        }

        img {
          width: 18pt;
          height: 18pt;
        }
      }
    }

    .con-content {
      margin-top: 20px;

      .content-center {
        margin-bottom: 30px;
        padding: 20px 20px 10px;
        background: #fff;
        border-radius: 20px;

        .content-top {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .content-topLeft {
            div:nth-child(1) {
              // font-size: 16pt;
              font-size: 29px;
              font-weight: bold;
              display: flex;
              align-items: center;

              span {
                border: 1px solid rgba(226, 33, 33, 1);
                font-size: 24px;
                padding: 4px 10px;
                margin-left: 15px;
                margin-top: 4px;
                color: rgba(226, 33, 33, 1);
              }
            }

            div:nth-child(2) {
              margin: 10px 0;

              span {
                color: rgba(102, 102, 102, 1);
                font-size: 24px;
                margin-right: 10px;
              }
            }

            div:nth-child(3) {
              span {
                color: rgba(102, 102, 102, 1);
                font-size: 24px;
                margin-right: 10px;
                background: rgba(245, 245, 245, 1);
                padding: 10px 20px;
              }
            }
          }

          .content-topRight {
            img {
              width: 58pt;
              height: 58pt;
            }
          }
        }
      }

      .content-depa {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 12pt;
        color: rgba(102, 102, 102, 1);
        padding: 30px 0;
        border-bottom: 1px solid rgba(241, 241, 241, 1);

        span:nth-child(2) {
          color: rgba(78, 162, 124, 1);
          font-size: 14pt;
        }
      }

      .content-footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-top: 20px;

        div:nth-child(2) {
          display: flex;

          dl {
            display: flex;
            align-items: center;
            margin-left: 100px;

            img {
              width: 30pt;
              height: 30pt;
            }

            dd {
              font-size: 30px;
              color: rgba(102, 102, 102, 1);
              margin-left: 15px;
              margin-top: -10px;
            }
          }
        }
      }
    }

    .con-content1 {
      margin-top: 20px;

      .content-center {
        margin-bottom: 30px;
        padding: 20px 20px 10px;
        background: #fff;
        border-radius: 20px;

        .content-top {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;

          .content-topLeft {
            width: 100%;

            .topLeft {
              display: flex;
              align-items: center;
              justify-content: space-between;

              .topTitle {
                font-size: 29px;
                font-weight: bold;
              }

              .topRight {
                font-size: 24px;
                color: #4EA27C;
                padding: 8px 25px;
              }

              .titleGreen {
                background: rgba(78, 162, 124, 0.1);
                color: #4EA27C;
              }

              .titleRed {
                background: rgba(226, 33, 33, 0.1);
                color: #E22121;
              }
            }

            .topCenter {
              color: rgba(102, 102, 102, 1);
              font-size: 26px;
              margin-right: 10px;
              margin: 15px 0 40px 0;
            }

            .topCenter1 {
              color: rgba(102, 102, 102, 1);
              font-size: 22px;
              padding: 10px 0;
            }

          }

          .content-topRight {
            img {
              width: 58pt;
              height: 58pt;
            }
          }
        }
      }
    }

    .menu-log {
      background: #fff;
      position: fixed;
      left: 0;
      bottom: 0;
      height: 300px;
      width: 100%;
      transform: 1s;
      z-index: 999;
      border-radius: 10px 10px 0 0;

      div {
        height: 33%;
        font-size: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      div:nth-child(1) {
        border-bottom: 1px solid #f4f4f4;
      }

      div:nth-child(2) {
        border-bottom: 1px solid #f4f4f4;
      }
    }
  }
}

// ::v-deep .van-list__loading {
//   line-height: 80px;
//   background: #f7f9fa;
// }
::v-deep .van-list__finished-text {
  line-height: 80px;
  background: #f7f9fa;
}</style>
